export function isAbsoluteLink(link) {
    return /^((https?:\/\/)|\/\/)/.test(link);
}
